module.exports = __webpack_public_path__ + "img/104ne.29526f73.svg";